import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OverviewContentService {
  title = signal<string>('');
  description = signal<string>('');

  setContent(title: string, description: string): void {
    this.title.set(title);
    this.description.set(description);
  }
}
